import React from 'react';
import withApollo from '../../lib/withApollo';
import HelpCenter from 'components/HelpCenter/HelpCenter';
import Footer from 'components/General/Footer';
import DashboardPage from 'components/Dashboard/DashboardPage';
import { getUser } from 'helpers/token';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

const HelpPage = () => {
  const router = useRouter();

  const [user, setUser] = useState(null);

  useEffect(() => {
    setUser(getUser());
  }, []);

  const { open } = router.query;

  const generatedOgImage = `https://tfog.b-cdn.net/api/post?title=${encodeURIComponent(
    `TravelFeed Help Center`,
  )}&image=${encodeURIComponent(
    'https://img.travelfeed.io/tvt3st%2F2023-10-12-10-10-618-help-center-question-mark-jpg',
  )}`;

  return (
    <>
      <DashboardPage
        ogImage={generatedOgImage}
        justTitle="TravelFeed Help Center"
        description="Need help using TravelFeed? Visit our Help Center for easy guides on creating, editing, and optimizing your travel blogs."
        showForAnyone
        open={open}
        label="help"
        content={
          <>
            <HelpCenter />
            {user === undefined && <Footer />}
          </>
        }
      />
    </>
  );
};

export default withApollo(HelpPage);
